<span class="text-title">Quadro de Solicitações</span>
<aionz-purchasing-filters-toolbar
  [branches]="branches()"
  [buyers]="visibleBuyers()"
  [isBuyersLoading]="isBuyersLoading()"
  [selectedBranchId]="selectedBranchId()"
  [selectedBuyerId]="selectedBuyerId()"
  [selectedOrderBy]="selectedOrderBy()"
  [searchTerm]="globalSearchTerm()"
  (branchChange)="handleBranchFilterChange($event)"
  (buyerChange)="handleBuyerFilterChange($event)"
  (orderChange)="handleOrderChange($event)"
  (buyersScrolled)="onBuyersScrolled()"
  (searchChange)="handleSearchChange($event)"
  (clearFilters)="clearFilters()" />
<div class="board">
  <aionz-product-integration-notification (onClose)="closeNotification()" />
  <div
    class="boards-container"
    aionzKanbanKeyboardNav
    [style.height.px]="containerHeight()">
    @if (hasNoPurchases()) {
      <div class="flex-col items-center justify-center empty-board">
        <aionz-empty-content
          title="Nenhuma solicitação encontrada"
          description="Nenhuma solicitação foi encontrada com este filtro. Limpe o filtro ou tente outra combinação.">
          @if (hasActiveFilters()) {
            <button mat-flat-button color="primary" (click)="clearFilters()">
              <mat-icon>filter_alt_off</mat-icon>
              Limpar filtros
            </button>
          }
        </aionz-empty-content>
      </div>
    } @else {
      @for (board of boards(); track board.status) {
        <aionz-kanban-board
          [boardId]="board.status"
          [title]="board.title"
          [purchases]="getPurchasesByStatus(board.status)"
          [boardStatuses]="boardIds()"
          [showTimeBadge]="true"
          [averageSlaLabel]="averageSlaLabels()[board.status] ?? '--'"
          [searchTerm]="globalSearchTerm()"
          [collapsed]="isBoardCollapsed(board.status)"
          (collapsedChange)="setBoardCollapsed(board.status, $event)"
          (cardClicked)="handleCardClicked($event)"
          (changeBuyer)="handleChangeBuyer($event)"
          (cancelPurchaseRequest)="handleCancelPurchaseRequest($event)"
          (openAuditReport)="handleOpenAuditReport($event)"
          (openQuotationMapPdf)="handleOpenQuotationMapPdf($event)" />
      }
    }
  </div>
</div>
